import { render } from "./FluorineRepublika.vue?vue&type=template&id=19054a7c&scoped=true"
import script from "./FluorineRepublika.vue?vue&type=script&lang=js"
export * from "./FluorineRepublika.vue?vue&type=script&lang=js"

import "./FluorineRepublika.vue?vue&type=style&index=0&id=19054a7c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19054a7c"]])

export default __exports__